<template>
  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <PCard :style="{ width: '600px' }" class="relative-position">
      <q-card-section>
        <span class="text-md"> {{ props?.organisationTitle }} is added. </span>
      </q-card-section>

      <q-card-section
        class="rounded-borders text-neutral-90 text-center q-py-md"
      >
        <q-form class="q-mt-none" @submit.prevent="onProceed">
          <div class="flex items-center">
            <p class="text-sm text-neutral-80 q-mr-xs">
              Would you like to add a
            </p>
            <PSelectInput
              v-model="selectedOption"
              :options="props?.dropdownOptions"
              placeholder="Select option"
              :style="{ width: '188px' }"
              :validations="{ required: true }"
            />
            <p class="text-sm text-neutral-80 q-ml-xs">to this organisation?</p>
          </div>
        </q-form>
      </q-card-section>

      <q-card-section
        class="flex justify-between items-center q-px-md q-pt-sm q-pb-md"
      >
        <PBtn flat label="Later" class="text-primary" @click="onLater" />
        <PBtn
          label="Proceed"
          color="brown"
          :loading="isLoading"
          @click="onProceed"
        />
      </q-card-section>
    </PCard>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from "quasar";

const router = useRouter();
const { dialogRef, onDialogHide, onDialogCancel } = useDialogPluginComponent();

const props = defineProps({
  organisationTitle: {
    type: String,
    default: "",
  },
  closeDialog: {
    type: Function,
    default: () => {},
  },
  dropdownOptions: {
    type: Array,
    default: () => [
      { label: "Customer", value: "customer" },
      { label: "Vendor", value: "vendor" },
    ],
  },
});

defineEmits(["proceed", "hide"]);

const selectedOption = ref("");
const isLoading = ref(false);

const onLater = () => {
  onDialogCancel();

  props.closeDialog();
};

const onProceed = async () => {
  if (selectedOption.value) {
    isLoading.value = true;

    try {
      if (selectedOption.value === "customer") {
        await router.push({
          hash: "#customers",
          name: "users",
          query: { add: "true" },
        });
      } else if (selectedOption.value === "vendor") {
        await router.push({
          hash: "#vendors",
          name: "users",
          query: { add: "true" },
        });
      }
    } catch (error) {
      console.error("Failed to navigate:", error);
    } finally {
      isLoading.value = false;
    }
  }
};
</script>
